import React from "react";

import { CustomersPanel } from "../../components/customer/index.js";

export default () => <CustomersPanel />;
